import React from 'react';

export interface ResourceGroupContextProps {
  registerResource?: (resourceInfo: { resourceId: number; dataDst?: string | string[] }) => void;
  unregisterResource?: (resourceInfo: { resourceId: number }) => void;
  parentResourceKey?: string;
}

const ResourceGroupContext = React.createContext<ResourceGroupContextProps>({});

export default ResourceGroupContext;
